import type { Language } from '../tiger/interfaces/Antiloop'
import { getText, TextKeys } from '../tiger/libs/TextRepository'
import { BackOfficeEnfucePayoutStateV3, type BackOfficePayoutDataResponseDtoV3, type BackOfficePayoutPatchDtoV3 } from '../types/payoutV3'

type PayoutMutation = { payoutId: string; payout: BackOfficePayoutPatchDtoV3 }

type GetPayoutsProps = {
  mutation: (payout: PayoutMutation) => Promise<unknown>
  language: Language
  isLoading?: boolean
}

export const getPayoutsActions = ({ mutation, language, isLoading }: GetPayoutsProps) => [
  {
    icon: 'book',
    tooltip: getText(TextKeys.accountingInvoicesToolTipBook, language),
    disabled: isLoading,
    onClick: (event: any, payout: BackOfficePayoutDataResponseDtoV3) =>
      mutation({
        payoutId: payout.id,
        payout: { state: BackOfficeEnfucePayoutStateV3.BOOKED },
      }),
  },
  {
    icon: 'description',
    tooltip: getText(TextKeys.accountingPayoutsToolTipCredit, language),
    disabled: isLoading,
    onClick: (event: any, payout: BackOfficePayoutDataResponseDtoV3) =>
      mutation({
        payoutId: payout.id,
        payout: { state: BackOfficeEnfucePayoutStateV3.SETTLED },
      }),
  },
  {
    icon: 'clear',
    tooltip: getText(TextKeys.accountingPayoutsToolTipCancel, language),
    disabled: isLoading,
    onClick: (event: any, payout: BackOfficePayoutDataResponseDtoV3) =>
      window.confirm('Are you sure ?') &&
      mutation({
        payoutId: payout.id,
        payout: {
          state: BackOfficeEnfucePayoutStateV3.CANCELLED,
        },
      }),
  },
]
